export default {
    WAPI_URL: 'https://cta.ucc-bsnl.co.in', // 'http://localhost:8081/'
    DEFAULT_DOMAIN: 'bsn.ltd',
    DEFAULT_DOMAIN_PUBLIC_IP: '206.1.30.136',
    DONUT_CHART_COLORS: ['#294e79', '#D2D3D4', '#0da3e2', '#EE2737', '#B6DCF3', '#0D73BB'],
    PRIMARY_TEXT_COLOR: '#0da3e2',
    CTATYPE_PIE_CHART_COLORS: ['#0da3e2', '#294e79', '#B6DCF3'],
    CLICKMETRICS_PIE_CHART_COLORS: ['#0da3e2', '#294e79'],
    REGISTERED_DLT: 'BSNL'
}
